<template>
  <div class="layout">
    <!-- <login></login> -->
    <logo></logo>
    <menus></menus>
    <router-view/>
    <foot></foot>
  </div>
</template>

<script>
import login from '@/components/Login'
import menus from '@/components/Menus'
import foot from '@/components/Foot'
import logo from '@/components/Logo'
import { oauthToken } from '@/api/user'

export default {
  components: {
    login,
    logo,
    menus,
    foot
  },
  created () {
    oauthToken().then(res => {
      localStorage.setItem('access_token', res.data.access_token)
    })
    // console.log(this.$route)
  },
  methods: {}
}
</script>


